import React, { useState, useCallback } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';

import AdminTable from '@common/components/table/AdminTable';
import ApiService from '@common/services/ApiService';
import VcmUnitResponsesFilters from './VcmUnitResponsesFilters';

const styles = (theme) => ({
  exportHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(
      25
    )} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`
  }
});

const fields = [
  'unit_code',
  'unit_title',
  'vcm_courses',
  'vcm_url',
  'educator_url',
  'division_name',
  'department_name',
  'currency_status',
  'currency_date'
];

const metadata = {
  unit_code: { label: 'Unit Code', sortable: true },
  unit_title: { label: 'Unit Title' },
  vcm_courses: { label: 'VCM Courses' },
  vcm_url: { label: 'VCM Revision', type: 'link', label_field: 'vcm_revision' },
  educator_url: { label: 'Educator Name', type: 'link', label_field: 'educator_name', sortable: true, sortKey: 'educator_name' },
  division_name: { label: 'Division' },
  department_name: { label: 'Department' },
  currency_status: { label: 'Currency Status' },
  currency_date: { label: 'Currency Date' }
};

const currentYear = new Date().getFullYear();

const VcmUnitResponses = ({ classes }) => {
  const api = new ApiService();

  const [filters, setFilters] = useState({ year_eq: currentYear.toString() });
  const [order, setOrder] = useState('');
  const [orderBy, setOrderBy] = useState('');

  const handleApplyFilters = useCallback((newFilters) => setFilters(newFilters), []);

  const handleApplySorting = useCallback((newOrder, newOrderBy) => {
    setOrder(newOrder);
    setOrderBy(newOrderBy);
  }, []);

  const exportURL = useCallback(() => {
    const sortingParams = { direction: order, field: orderBy };
    return api.fullUrl('/api/v1/reports/vcm_unit_responses.csv', filters, null, null, sortingParams, null);
  }, [order, orderBy, filters]);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Paper>
          <VcmUnitResponsesFilters handleApplyFilters={handleApplyFilters} />
        </Paper>
      </Grid>
      <Grid size={12}>
        <Paper>
          <Grid container className={classes.exportHeader} justifyContent="space-between">
            <Typography variant="h6">VCM Unit Responses</Typography>
            <a href={exportURL()} target="_blank">
              <Button color="secondary" size="small" variant="contained">
                <Typography variant="button">Export</Typography>
              </Button>
            </a>
          </Grid>
          <AdminTable
            showTablePagination
            fields={fields}
            filters={filters}
            handleApplySorting={handleApplySorting}
            metadata={metadata}
            onCellEdit={{}}
            order="asc"
            orderBy="unit_code"
            resource="reports/vcm_unit_responses"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withStyles(VcmUnitResponses, styles, { withTheme: true });
